import styled from 'styled-components'

export const ContactFormBox = styled.div`
  width: 100%;
  max-width: 705px;

  border-radius: 10px;
  padding: 50px 70px 0 70px;

  @media (max-width: 900px) {
    padding: 50px 33px 0 33px;
  }
`
